import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "toolbar" }

import { ref, reactive, onMounted, computed } from "vue";
import { ElMessage } from "element-plus";
import { useStore } from "vuex";
import { TenantServiceApi } from "@/services/dataService";


export default /*@__PURE__*/_defineComponent({
  __name: 'TenantApiKeys',
  setup(__props) {

const store = useStore();
const currentUser = computed(() => store.getters.getUser);
const defaultTenantId = computed(() => currentUser.value?.tenant_id);

const effectiveTenantId = computed(() => defaultTenantId.value);

const loading = ref(false);
const items = ref<any[]>([]);

const createVisible = ref(false);
const createForm = reactive<{ name: string; description?: string }>({
  name: "",
  description: "",
});

const onceVisible = ref(false);
const onceData = reactive<{ access_key: string; secret_key: string }>({
  access_key: "",
  secret_key: "",
});

const copy = async (text: string) => {
  try {
    await navigator.clipboard.writeText(text);
    ElMessage.success("已复制到剪贴板");
  } catch {
    ElMessage.error("复制失败");
  }
};

const loadKeys = async () => {
  if (!effectiveTenantId.value) {
    ElMessage.warning("未检测到租户ID，请输入或使用管理员账号登录");
    return;
  }
  loading.value = true;
  try {
    const resp = await TenantServiceApi.listApiKeys(effectiveTenantId.value);
    items.value = resp?.data?.data || [];
  } catch (e: any) {
    ElMessage.error(e?.message || "加载失败");
  } finally {
    loading.value = false;
  }
};

const openCreate = () => {
  if (!effectiveTenantId.value) {
    ElMessage.warning("请先提供租户ID");
    return;
  }
  createVisible.value = true;
  createForm.name = "";
  createForm.description = "";
};

const submitCreate = async () => {
  if (!effectiveTenantId.value) return;
  try {
    const resp = await TenantServiceApi.createApiKey(effectiveTenantId.value, {
      name: createForm.name,
      description: createForm.description,
    });
    const data = resp?.data?.data;
    if (data?.access_key && data?.secret_key) {
      onceData.access_key = data.access_key;
      onceData.secret_key = data.secret_key;
      onceVisible.value = true;
      createVisible.value = false;
      loadKeys();
      return;
    }
    ElMessage.error(resp?.data?.message || "创建失败");
  } catch (e: any) {
    ElMessage.error(e?.message || "创建失败");
  }
};

const removeKey = async (row: any) => {
  if (!effectiveTenantId.value) return;
  try {
    const resp = await TenantServiceApi.deleteApiKey(
      effectiveTenantId.value,
      row.id
    );
    if (resp?.data?.code === 0) {
      ElMessage.success("已删除");
      loadKeys();
    } else {
      ElMessage.error(resp?.data?.message || "删除失败");
    }
  } catch (e: any) {
    ElMessage.error(e?.message || "删除失败");
  }
};

onMounted(loadKeys);

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[11] || (_cache[11] = _createElementVNode("div", { class: "flex1" }, null, -1)),
      _createVNode(_component_el_button, {
        type: "success",
        onClick: openCreate
      }, {
        default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
          _createTextVNode("创建 API 密钥", -1)
        ]))]),
        _: 1
      })
    ]),
    _createVNode(_component_el_alert, {
      type: "info",
      "show-icon": "",
      closable: false,
      class: "mb12"
    }, {
      title: _withCtx(() => [...(_cache[12] || (_cache[12] = [
        _createElementVNode("div", null, "Secret Key 仅在创建时显示一次，请妥善保存。", -1)
      ]))]),
      _: 1
    }),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      data: items.value,
      size: "small",
      border: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "name",
          label: "名称",
          "min-width": "160"
        }),
        _createVNode(_component_el_table_column, {
          prop: "access_key",
          label: "Access Key",
          "min-width": "240"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_input, {
              modelValue: scope.row.access_key,
              "onUpdate:modelValue": ($event: any) => ((scope.row.access_key) = $event),
              readonly: "",
              size: "small"
            }, {
              append: _withCtx(() => [
                _createVNode(_component_el_button, {
                  onClick: ($event: any) => (copy(scope.row.access_key)),
                  size: "small"
                }, {
                  default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                    _createTextVNode("复制", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 2
            }, 1032, ["modelValue", "onUpdate:modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "is_active",
          label: "状态",
          width: "90"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_tag, {
              type: scope.row.is_active ? 'success' : 'info'
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(scope.row.is_active ? "启用" : "停用"), 1)
              ]),
              _: 2
            }, 1032, ["type"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "created_at",
          label: "创建时间",
          "min-width": "160"
        }),
        _createVNode(_component_el_table_column, {
          prop: "last_used_at",
          label: "最近使用",
          "min-width": "160"
        }),
        _createVNode(_component_el_table_column, {
          label: "操作",
          width: "140",
          fixed: "right"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_popconfirm, {
              title: "确认删除该密钥？",
              onConfirm: ($event: any) => (removeKey(scope.row))
            }, {
              reference: _withCtx(() => [
                _createVNode(_component_el_button, {
                  size: "small",
                  type: "danger"
                }, {
                  default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                    _createTextVNode("删除", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["onConfirm"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"])), [
      [_directive_loading, loading.value]
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: createVisible.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((createVisible).value = $event)),
      title: "创建 API 密钥",
      width: "520px"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (createVisible.value = false))
        }, {
          default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
            _createTextVNode("取消", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: submitCreate
        }, {
          default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
            _createTextVNode("创建", -1)
          ]))]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: createForm,
          "label-width": "100px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "名称" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: createForm.name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((createForm.name) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "描述" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: createForm.description,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((createForm.description) = $event)),
                  type: "textarea"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: onceVisible.value,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((onceVisible).value = $event)),
      title: "请妥善保存您的密钥",
      width: "560px"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[8] || (_cache[8] = ($event: any) => (onceVisible.value = false))
        }, {
          default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
            _createTextVNode("我已保存", -1)
          ]))]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_alert, {
          type: "warning",
          "show-icon": "",
          closable: false,
          class: "mb12"
        }, {
          title: _withCtx(() => [...(_cache[17] || (_cache[17] = [
            _createElementVNode("div", null, "Secret Key 仅显示一次。关闭此弹窗后将无法再次查看。", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_el_form, { "label-width": "110px" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "Access Key" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: onceData.access_key,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((onceData.access_key) = $event)),
                  readonly: ""
                }, {
                  append: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (copy(onceData.access_key)))
                    }, {
                      default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                        _createTextVNode("复制", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "Secret Key" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: onceData.secret_key,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((onceData.secret_key) = $event)),
                  readonly: ""
                }, {
                  append: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (copy(onceData.secret_key)))
                    }, {
                      default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                        _createTextVNode("复制", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})